import { render, staticRenderFns } from "./tournamentInfo.vue?vue&type=template&id=7934faf0&scoped=true"
import script from "./tournamentInfo.vue?vue&type=script&lang=js"
export * from "./tournamentInfo.vue?vue&type=script&lang=js"
import style0 from "./tournamentInfo.vue?vue&type=style&index=0&id=7934faf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7934faf0",
  null
  
)

export default component.exports